import * as actionCodes from '../action-type-codes';

export const stepBarInit = (lobSteps: any) => {
    return {
        type: actionCodes.STEPBAR_INITIALIZE,
        lobSteps
    }
}

export const stepBarReInit = (newLobSteps: any) => {
    return {
        type: actionCodes.STEPBAR_REINITIALIZE,
        newLobSteps
    }
}

export const goToNextStep = () => {
    return {
        type: actionCodes.STEPBAR_SAVE_AND_NEXT
    }
}

export const goToPrevStep = (stepNumber: any) => {
    return {
        type: actionCodes.STEPBAR_GO_PREVIOUS_STEP,
        stepNumber
    }
}

export const editPrevStep = (stepNumber: any, updatedStepData: any) => {
    return {
        type: actionCodes.STEPBAR_EDIT_PREVSTEP,
        stepNumber,
        updatedStepData
    }
}

export const initOnRoute = (stepNumber: number) => {
    return {
        type: actionCodes.STEPBAR_INIT_ON_ROUTE,
        stepNumber
    }
}

export const saveSelectionValue = (selectionValue: string, otherValue?: string) => {
    if (otherValue === undefined) {
        return {
            type: actionCodes.STEPBAR_SAVE_SELECTION_VALUE,
            selectionValue
        }
    } else {
        return {
            type: actionCodes.STEPBAR_SAVE_SELECTION_VALUE,
            selectionValue, otherValue
        }
    }
}

export const saveSelectionValueOnModal = (selectionValue: string, otherValue?: string) => {
    if (otherValue === undefined)
        return {
            type: actionCodes.STEPBAR_SAVE_SELECTION_VALUE_ON_MODAL,
            selectionValue
        }
    else
        return {
            type: actionCodes.STEPBAR_SAVE_SELECTION_VALUE_ON_MODAL,
            selectionValue, otherValue
        }
}

export const putValueOnStep = (stepNumber: number, selectionValue: string) => {
    return {
        type: actionCodes.STEPBAR_PUT_VALUE_ON_STEP,
        selectionValue, stepNumber
    }
}

export const putValueOnStepOther = (stepNumber: number, otherValue: string) => {
    return {
        type: actionCodes.STEPBAR_PUT_VALUE_ON_OTHER,
        otherValue, stepNumber
    }
}

export const dismissModal = () => {
    return {
        type: actionCodes.STEPBAR_DISMISS_MODAL
    }
}

export const saveSelectedLob = (selectedLobName: any) => {
    return {
        type: actionCodes.STEPBAR_SAVE_LOB,
        selectedLobName
    }
}

export const saveVehicleLobData = (vehicleLxData: any, vehicleCxData: any, tagData: any = {}) => {
    return {
        type: actionCodes.LOBDATA_SAVE_SELECTED_VALUE,
        vehicleLxData, vehicleCxData, tagData
    }
}

export const stepbarStateReinit = (newStateData: any ) => {
    return {
        type: actionCodes.STEPBAR_STATE_REINIT,
        newStateData
    }
}